import queryString from 'query-string';

const queryParam = function (param, { type } = {}) {
  return function decorator(target, key, descriptor) {
    const { initializer } = descriptor;
    delete descriptor.initializer;
    delete descriptor.writable;
    descriptor.set = function setter(val) {
      const query = queryString.parse(window.location.search);
      query[param] = val;
      if (!val || (Array.isArray(val) && val.length === 0)) {
        delete query[param];
      }
      window.history.pushState(query, '', `?${queryString.stringify(query)}`);
      this.requestUpdate && this.requestUpdate();
    };
    descriptor.get = function getter() {
      const query = queryString.parse(window.location.search);
      if (initializer && query[param] === undefined) {
        return initializer();
      }
      if (type === 'array' && query[param] && !Array.isArray(query[param])) {
        query[param] = [query[param]];
      }
      return query[param];
    };
    return descriptor;
  };
};

export default queryParam;
